import { render, staticRenderFns } from "./TwoFactorAdmin.vue?vue&type=template&id=4a66ec2a&scoped=true&"
import script from "./TwoFactorAdmin.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAdmin.vue?vue&type=style&index=0&id=4a66ec2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a66ec2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VDataTable,VSpacer,VTextField})
